import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";
import { PointRecord } from "../../helper/PointRecord";
import { ItemDisplayRecord } from "../shared/ItemDisplayRecord";
import { ItemTypeDisplayValues } from "../shared/ItemTypeDisplayValues";
// import orientations from "../../../../constants/orientations";

export const NarrativeCardDisplayRecord = Record({
  label: null,
  id: null,
  parent: null,
  index: null,
  cards: List(),
  orientation: null,
  rect: FlatRectRecord(),
  transform: PointRecord(),
  depth: 0,
  position: List(),
  selected: false,
  itemDisplay: ItemDisplayRecord(),
  typeData: ItemTypeDisplayValues()
});

const data = {
  objects: {
    rect: "FlatRectRecord",
    itemDisplay: "ItemDisplayRecord",
    position: "List",
    transform: "PointRecord",
    typeData: "ItemTypeDisplayValues"
  },
  collections: {
    cards: "NarrativeCardDisplayRecord"
  }
};
createFromJS.registerCallback(
  "NarrativeCardDisplayRecord",
  createFromJS.createNestedCallback(NarrativeCardDisplayRecord, data)
);
